import { type Theme, useTheme } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { GridOverlay } from '@mui/x-data-grid';

const getStyles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '& *': {
      color: theme.palette.action.disabled
    }
  }
});

const NoRowsOverlay = () => {
  const theme = useTheme();
  const classes = getStyles(theme);
  return (
    <GridOverlay sx={classes.root}>
      <Typography variant="h6">No hay datos para mostrar</Typography>
      {/* <ContactMailIcon style={{ fontSize: 50 }} /> */}
    </GridOverlay>
  );
};

export default NoRowsOverlay;
